import repositories from '..';

const resource = '/master/major';

export default {
  get: (data: any) => repositories.get(`${resource}?facultyId=${data}`),
};
